import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const shopCategories = [
  { 
    name: 'Rings', 
    path: '/rings', 
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'Explore our stunning collection of rings, from classic solitaires to intricate vintage designs. Each piece is crafted with precision and love.'
  },
  { 
    name: 'Necklaces', 
    path: '/necklaces', 
    image: 'https://i.etsystatic.com/6027990/r/il/e90620/421649366/il_fullxfull.421649366_cz3s.jpg',
    description: 'Discover elegant necklaces that add grace to any occasion. From delicate chains to statement pieces, our necklaces are designed to impress.'
  },
  { 
    name: 'Earrings', 
    path: '/earrings', 
    image: 'https://tse1.mm.bing.net/th/id/OIP.h7Kwr7GHBw41r6dyXqsnQAAAAA?rs=1&pid=ImgDetMain&o=7&rm=3',
    description: 'Our earring collection features timeless designs – from everyday studs to glamorous chandeliers. Handcrafted to perfection.'
  },
  { 
    name: 'Bangles', 
    path: '/bangles', 
    image: 'https://www.dhanalakshmijewellers.com/wp-content/uploads/2020/03/goldbanglescover.jpg',
    description: 'Adorn your wrists with our beautiful bangles. Available in various styles – traditional, modern, and everything in between.'
  },
];

const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [failedImages, setFailedImages] = useState({});
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSelectedCategory(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleImageError = (name) => {
    setFailedImages((prev) => ({ ...prev, [name]: true }));
  };

  const handleViewDetails = (cat) => {
    setSelectedCategory(cat);
  };

  return (
    <div className="min-h-screen bg-white text-stone-800 p-8">
      <h1 className="text-4xl font-bold mb-4">Shop</h1>
      <p className="text-stone-600 text-lg mb-8">
        Explore our exquisite collections crafted with purity and passion.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {shopCategories.map((cat) => {
          const imageFailed = failedImages[cat.name];
          return (
            <div
              key={cat.name}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-stone-200"
            >
              <Link to={cat.path} className="block">
                <div className="aspect-square overflow-hidden bg-stone-100">
                  {!imageFailed ? (
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                      onError={() => handleImageError(cat.name)}
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-full h-full bg-amber-100 flex items-center justify-center">
                      <span className="text-stone-800 font-medium">{cat.name}</span>
                    </div>
                  )}
                </div>
              </Link>
              <div className="p-4">
                <Link to={cat.path}>
                  <h3 className="text-xl font-semibold text-stone-800 mb-2 hover:text-amber-600 transition-colors">
                    {cat.name}
                  </h3>
                </Link>
                <button
                  onClick={() => handleViewDetails(cat)}
                  className="w-full py-2 border border-amber-500 text-amber-600 rounded-lg hover:bg-amber-500 hover:text-white transition-colors duration-300 font-medium"
                >
                  View Details
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {selectedCategory && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div
            ref={modalRef}
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
          >
            <div className="relative">
              <button
                onClick={() => setSelectedCategory(null)}
                className="absolute top-4 right-4 text-stone-500 hover:text-stone-800 transition-colors z-10"
              >
                <FaTimes size={24} />
              </button>
              <div className="p-6">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-1/2">
                    <img
                      src={selectedCategory.image}
                      alt={selectedCategory.name}
                      className="w-full h-auto object-cover rounded-xl shadow-md"
                    />
                  </div>
                  <div className="md:w-1/2">
                    <h2 className="text-2xl font-bold text-stone-800 mb-2">{selectedCategory.name}</h2>
                    <p className="text-stone-600 mb-4">{selectedCategory.description}</p>
                    <div className="space-y-2">
                      <p className="text-sm text-stone-500">
                        <span className="font-medium">Category:</span> {selectedCategory.name}
                      </p>
                      <p className="text-sm text-stone-500">
                        <span className="font-medium">Explore our full range:</span>
                      </p>
                    </div>
                    <Link
                      to={selectedCategory.path}
                      className="inline-block mt-4 px-6 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors"
                      onClick={() => setSelectedCategory(null)}
                    >
                      Browse Collection
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shop;